<template>
  <div
    class="row"
    v-if="borrow"
  >
    <div class="col-md-12">
      <template v-if="borrow.type === 'Purchasing'">
        <installment-form :editable="editable" />
      </template>
      <template v-else-if="borrow.type === 'Pawn'">
        <pawn-form :editable="editable" />
      </template>
      <template v-else>
        <personal-pay-day-form :editable="editable" />
      </template>
    </div>
  </div>
</template>

<script>
import PersonalPayDayForm from '@/views/borrows/_components/forms/PersonalPayDayForm'
import InstallmentForm from '@/views/borrows/_components/forms/InstallmentForm'
import PawnForm from '@/views/borrows/_components/forms/PawnForm'

export default {
  name: 'CancelledForm',
  components: {
    PawnForm,
    InstallmentForm,
    PersonalPayDayForm
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      borrow: null
    }
  },
  methods: {
    getBorrow () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/get-borrow', {
        id: this.$route.params.borrow_id
      }).then(({ data }) => {
        if (data.data) {
          this.borrow = data.data
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    }
  },
  mounted () {
    this.getBorrow()
  }
}
</script>

<style scoped>

</style>
